module.exports = __webpack_public_path__ + "img/fr.7c8b4eb6.svg";